import { applyAbsoluteLinks, removeEmptyWikiSections } from './wiki-links';

const WIKTIONARY_FALLBACK_BASE = 'https://en.wiktionary.org/wiki/';

export function resolveWiktionaryLinks(html: string | undefined): string | undefined {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const rawBaseHref = doc.querySelector('base')?.getAttribute('href');
  const base = rawBaseHref
    ? new URL(rawBaseHref.startsWith('//') ? `https:${rawBaseHref}` : rawBaseHref).href
    : WIKTIONARY_FALLBACK_BASE;

  applyAbsoluteLinks(doc, base);
  removeEmptyWikiSections(doc);

  return doc.body.innerHTML;
}

export function extractWiktionaryDefinition(html: string | undefined): string | undefined {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  for (const heading of Array.from(doc.querySelectorAll('h3'))) {
    const container = doc.createElement('div');
    let node: Element | null = heading;
    let sawDefinitionList = false;
    while (node && !sawDefinitionList) {
      container.appendChild(node.cloneNode(true));
      sawDefinitionList = node.tagName === 'DL';
      node = node.nextElementSibling;
    }
    if (sawDefinitionList) return container.innerHTML;
  }

  return html;
}
